export enum DashboardQueryValidationTypeEnum {
  WithOptionalFields = 'withOptionalFields',
  WithRequiredCountryCode = 'withRequiredCountryCode',
  WithRequiredSortOptions = 'withRequiredSortOptions',
}
